import { useState, useEffect } from "react";
import useFetch from "../../hooks/useFetch";


export default function GlobalForm(props) {
    const formElement = props.formEntries;
    const endpoint = props.endpoint;
    const sendButton = props.sendButton;
    const row = props.row;

    const [formData, setFormData] = useState({});
    const [message, setMessage] = useState('');
    const [sent, setSent] = useState(false);
    const { requestSetter: sendPostData, data: response } = useFetch(endpoint, 'POST');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const sendMessage = async (e) => {
        e.preventDefault();
        console.log(formData);
        try {
            sendPostData(formData);
            setSent(true);
            setMessage(response.message);
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }

    useEffect(() => {
        if (response && response.message) {
            setMessage(response.message);
        }
    }, [response]);

  return (
    <form onSubmit={sendMessage} method="POST" className="px-6 py-4">
        {formElement.map((form, index) => (
            <div className={`flex justify-center mb-4 ${row ? 'flex-row' : 'flex-col'}`} key={index}>
                <label htmlFor={form.entry} className="block text-sm font-medium text-gray-300">{form.entry}</label>
                <textarea 
                    type="text" id={form.entry} name={form.entry} 
                    className="mt-1 p-2 w-full rounded-md bg-gray-700 border border-gray-600 
                    focus:outline-none focus:border-blue-500 resize-none" rows={form.rows} required
                    onChange={handleChange}
                />
            </div>
        ))}
        <div className="text-center">
            {message === 'Sending request...' & !sent ? (
                <button 
                    className="px-4 py-2 text-white bg-blue-500 rounded-md transition duration-300 
                    hover:bg-blue-600 focus:outline-none cursor-pointer"
                >
                    {sendButton}
                </button>
            ) : (
                <p>{message}</p>
            )}
        </div>
    </form>
  )
}
